import { heroImages, fotoImages } from '@/constants/images';
import { businessInfo as business } from '@/content/globals';

export const heroContent = {
  image: {
    publicId: heroImages.ceramicCoating.publicId,
    alt: heroImages.ceramicCoating.alt,
  },
  headline: <>Advanced Ceramic Coating</>,
  subheadline: 'Hydrophobic shield for lasting shine.',
  cta: {
    href: '#coating-packages',
    label: 'Learn More',
    variant: 'primary',
  },
  secondaryCta: {
    href: '/book-now',
    label: 'Protect Today',
    variant: 'ghost',
  },
};

// Pricing lookup table for ceramic coating packages

export const ceramicCoatingPricing = [
  // Paint Enhancement (no paint correction level)
  { slug: 'crystal-small-paint-enhancement', price: 895 },
  { slug: 'crystal-medium-paint-enhancement', price: 995 },
  { slug: 'crystal-large-paint-enhancement', price: 1095 },
  { slug: 'crystal-x-large-paint-enhancement', price: 1195 },

  { slug: 'max-small-paint-enhancement', price: 1295 },
  { slug: 'max-medium-paint-enhancement', price: 1495 },
  { slug: 'max-large-paint-enhancement', price: 1695 },
  { slug: 'max-x-large-paint-enhancement', price: 1895 },

  { slug: 'pro-small-paint-enhancement', price: 1095 },
  { slug: 'pro-medium-paint-enhancement', price: 1195 },
  { slug: 'pro-large-paint-enhancement', price: 1295 },
  { slug: 'pro-x-large-paint-enhancement', price: 1495 },

  // Level 1 Paint Correction
  { slug: 'crystal-small-level-1', price: 1195 },
  { slug: 'crystal-medium-level-1', price: 1395 },
  { slug: 'crystal-large-level-1', price: 1595 },
  { slug: 'crystal-x-large-level-1', price: 1795 },

  { slug: 'max-small-level-1', price: 1795 },
  { slug: 'max-medium-level-1', price: 1995 },
  { slug: 'max-large-level-1', price: 2195 },
  { slug: 'max-x-large-level-1', price: 2395 },

  { slug: 'pro-small-level-1', price: 1495 },
  { slug: 'pro-medium-level-1', price: 1695 },
  { slug: 'pro-large-level-1', price: 1895 },
  { slug: 'pro-x-large-level-1', price: 2095 },

  // Level 2 Paint Correction
  { slug: 'crystal-small-level-2', price: 1495 },
  { slug: 'crystal-medium-level-2', price: 1695 },
  { slug: 'crystal-large-level-2', price: 1895 },
  { slug: 'crystal-x-large-level-2', price: 2095 },

  { slug: 'max-small-level-2', price: 2095 },
  { slug: 'max-medium-level-2', price: 2295 },
  { slug: 'max-large-level-2', price: 2495 },
  { slug: 'max-x-large-level-2', price: 2695 },

  { slug: 'pro-small-level-2', price: 1795 },
  { slug: 'pro-medium-level-2', price: 1995 },
  { slug: 'pro-large-level-2', price: 2195 },
  { slug: 'pro-x-large-level-2', price: 2395 },
];

export const cta1 = {
  id: 'gaurantee',
  overline: 'ceramic from Professional and certified installers',
  title: `ceramic coating packages for ${business.address.city}`,
  body: `At ${business.name}, our ceramic coatings stand as a pinnacle of paint enhancement for ${business.address.city}'s diverse drivers. Recognized for their exceptional defense against environmental contaminants and their ability to preserve that enviable lasting gloss, it's clear why our services are a local favorite. ${business.address.city}'s unique climate, with its blend of humid summers, chilly winters, and sporadic heavy rainfall, presents a distinct set of challenges for maintaining a vehicle's exterior. Our ceramic coatings are the proven solution, offering unparalleled protection tailored to meet and exceed these challenges.`,
  button: {
    href: '/book-now',
    iconName: 'LuSearch',
    text: 'Find out more',
  },
  image: {
    publicId: fotoImages.fotoImage10.publicId,
    alt: fotoImages.fotoImage10.alt,
  },
};
